module.exports = __webpack_public_path__ + "static/media/vintage_whisky_club.7f75d3f2.png";